/**
 * RelatoriosHubPage — catálogo de relatórios do ERP.
 */

import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { FileBarChart, Lock } from 'lucide-react'
import { usePermissions } from '../../../hooks/usePermissions'
import { canAccessErpReport } from '../../../utils/permissions'
import { ERP_REPORTS_CATALOG } from '../../../config/erpReportsCatalog'
import './RelatoriosHubPage.css'

function RelatoriosHubPage() {
  const navigate = useNavigate()
  const { hasPermission } = usePermissions()

  const reports = useMemo(
    () =>
      ERP_REPORTS_CATALOG.filter((item) =>
        canAccessErpReport(hasPermission, item.action)
      ),
    [hasPermission]
  )

  const enabledCount = reports.filter((r) => r.enabled).length

  return (
    <div className="relatorios-hub">
      <div className="relatorios-hub-header">
        <div>
          <h1 className="relatorios-hub-title">
            Relatórios <span className="relatorios-hub-title-accent">ERP</span>
          </h1>
          <p className="relatorios-hub-subtitle">
            Escolha o tipo de relatório e gere o PDF com o layout padrão do sistema
          </p>
        </div>
        <div className="relatorios-hub-badge">
          <FileBarChart size={14} />
          <span>
            {enabledCount} disponível{enabledCount === 1 ? '' : 'eis'}
          </span>
        </div>
      </div>

      {reports.length === 0 ? (
        <div className="relatorios-hub-empty">
          <Lock size={40} />
          <p>Nenhum relatório disponível para o seu perfil.</p>
        </div>
      ) : (
        <div className="relatorios-hub-grid">
          {reports.map((report) => {
            const Icon = report.icon
            return (
              <button
                key={report.id}
                type="button"
                className={`relatorios-hub-card${report.enabled ? '' : ' is-disabled'}`}
                onClick={() => {
                  if (report.enabled) navigate(report.path)
                }}
                disabled={!report.enabled}
                title={report.enabled ? report.label : 'Em breve'}
              >
                <div className={`relatorios-hub-card-icon ${report.color}`}>
                  <Icon size={22} />
                </div>
                <span className="relatorios-hub-card-label">{report.label}</span>
                <span className="relatorios-hub-card-desc">{report.description}</span>
                <span className="relatorios-hub-card-meta">
                  {report.category}
                  {!report.enabled ? ' · Em breve' : ''}
                </span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default RelatoriosHubPage
